import type { DestinationCoordinates } from "@/domain/destination/destination-coordinates.types"

export type BrowserLocationFailureKind =
  | "permission_denied"
  | "position_unavailable"
  | "timeout"
  | "unsupported"
  | "invalid_coordinates"
  | "stale"

export type BrowserLocationSuccess = {
  ok: true
  coordinates: DestinationCoordinates
  /**
   * Browser-reported 95% radius in metres (`coords.accuracy`), sanitised.
   * Undefined when the browser omits it or reports an unusable value; never blocks the flow.
   */
  accuracyMeters?: number
}

export type BrowserLocationFailure = {
  ok: false
  kind: BrowserLocationFailureKind
}

export type BrowserLocationResult = BrowserLocationSuccess | BrowserLocationFailure

/** One-shot customer wait for a GPS/network fix. Not an app-wide config knob. */
export const GEOLOCATION_TIMEOUT_MS = 10_000
